type TextMaxLengthViewProps = {
    text: string
    max?: number
}

const TextMaxLengthView = (props: TextMaxLengthViewProps) => {
    const max = props.max || 12;
    if(!props.text || props.text.length <= max) return <span>{props.text}</span>;
    
    let text = props.text + '';
    if(text.length > max) {
        text = text.substring(0, max) + "...";
    }
    
    return <span title={props.text}>{text}</span>;
}

export default  TextMaxLengthView;
